/*
 * Chillax — הוספה מהירה מתוך מגירת העגלה.
 * מוסיף בלי רענון עמוד ומרנדר מחדש את המגירה דרך ה-API של Dawn.
 */
class ChillaxCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.chx-upsell__add');
      if (button) this.add(button);
    });
  }

  async add(button) {
    const id = button.dataset.variantId;
    if (!id || button.getAttribute('aria-busy') === 'true') return;

    const drawer = document.querySelector('cart-drawer');
    const label = button.textContent;
    button.setAttribute('aria-busy', 'true');

    const body = {
      items: [{ id: Number(id), quantity: 1 }],
    };
    // מבקשים מראש את הסקשנים שצריך לרנדר, כדי לחסוך סיבוב נוסף
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (data.status) throw new Error(data.description || data.message);

      if (drawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('[chillax] upsell add failed', error);
      button.textContent = 'לא הצליח';
      setTimeout(() => {
        button.textContent = label;
      }, 2000);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('chillax-cart-upsell')) {
  customElements.define('chillax-cart-upsell', ChillaxCartUpsell);
}
